import React from 'react';
import SectionNavigation from './SectionNavigation';

export default React.memo(SectionNavigation);
